import InformationCircleIconPath from "@ingka/ssr-icon/paths/information-circle";

export default InformationCircleIconPath;
